<notifier-container></notifier-container>

<div class="m-content">
  <div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__body">
      <div class="m-wizard m-wizard--2 m-wizard--success" id="m_wizard">
        <h1 class="process-title">{{politica.policyName}}</h1> 
        <!-- <div *ngFor="let attribute of politicas">
          <app-section [attribute]="attribute"></app-section>
        </div> -->
      </div>
    </div>
  </div>
</div>
